
import { Component, OnInit, ViewChild } from "@angular/core";
import { ItineraryService } from "../shared/itinerary.service";
import { Observable, Subject } from "../../../node_modules/rxjs";
import { RestService } from "../shared/rest.service";
import { UserService } from "../pages/com.usblick.common/auth/user.service";
import { setting } from "../../../setting";
import { YourtripSummaryComponent } from "./content-summary/yourtrip-summary/yourtrip-summary.component";
import { Store } from "@ngrx/store";
import { AppState } from "app/core/profiles/storeProfile";
import { selectPermissions } from "app/core/profiles/profiles.selectors";
import { takeUntil } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { NotificationService } from "app/shared/notifications/notification.service";

@Component({
  selector: "usb-itinerary-summary",
  templateUrl: "./itinerary-summary.component.html",
  styleUrls: ["./itinerary-summary.component.scss"],
})
export class ItinerarySummaryComponent implements OnInit {
  @ViewChild(YourtripSummaryComponent)
  yourTripSummaryComponent!: YourtripSummaryComponent;
  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};
  _actualItinerary: any;
  _flightInfo: any;
  suggestions: any;
  partialReserve: boolean;
  qtyItemsToPartial: number = 0;
  cargoSugg = false;
  itinerary$: Observable<any[]>;
  public getClientsSettingAppBooking: any;
  public sectionSummary: any;
  public routeUploadFile: any;
  currencies: any[] = [];
  currencyAgency: any;
  netPriceAgent: number = 0;
  summaryItinerary: any[] = [];
  appLoading: boolean = true;
  reloadItinerary: boolean = false;
  routerStorage: any;
  private _loadingTimeout: any = null;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _itineraryService: ItineraryService,
    private restService: RestService,
    public userService: UserService,
    private store: Store<AppState>,
    private router: Router,
    private notificationService: NotificationService
  ) {

  }

  ngOnInit() {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.routerStorage = setting.apiStorageBooking;
    this.currencies = this.userService?.currenciesExchange;
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.currencyAgency = this.currencies?.find(c => c.code === selectedAgency.currency);

    if(!this.currencyAgency) {
      this.router.navigateByUrl('home');
      this.notificationService.warning('Moneda no configurada en la agencia');
    }
    this.routeUploadFile = setting.routeUploadFile;
    this.sectionSummary = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_summary);
    this.getPermissions();
    this._initData();
  }

  /** Suscribe a los permisos del store y los indexa en `permissionsMap` por nombre. */
  getPermissions(): void {
    this.permissions$ = this.store.select(selectPermissions);
    this.permissions$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });
  }

  /**
   * Indexa el array de permisos por `permission.name` para acceso O(1).
   * @param permissions Array de permisos desde el store.
   * @returns Mapa de permisos indexado por nombre.
   */
  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      map[permission.name] = permission;
    });
    return map;
  }


/** Inicializa el itinerario activo y se suscribe a updates del backend tras add/delete. */
  _initData() {
  if (this.userService.itineraryActive.length > 0) {
    var data = this.userService.itineraryActive;
    if (data) {
      if (data[0]) {

        this._actualItinerary = data[0];
        this._initFlights();
        this.getTotalTarifa();
        this.getItinerarySummary();
      } else {
        this._actualItinerary = null;
      }
    }
  }

  // Siempre suscribirse para recibir updates posteriores (post-add/delete).
  // Esto se activa cuando updateItinerary() completa → consultActiveItinerary()
  // → sendMessageActiveItinerary() → activeItinerary emite datos frescos del backend.
  let suscription = (this._itineraryService.activeItinerary as Observable<any>).subscribe(
    (data: any) => {
      if (data) {
        if (data[0]) {
          this._actualItinerary = data[0];
          this._initFlights();
          this.getTotalTarifa();
          this.getItinerarySummary();
        } else {
          this._actualItinerary = null;
        }
      }
    },
    (error) => {
      console.log("Error: ", error);
    }
  );
}

/** Carga `this._flightInfo` desde el endpoint `itinerary/{id}/fly`. */
_initFlights() {
  if (this._actualItinerary["id"] && this._actualItinerary["id"].length > 0) {
    const url = "itinerary/" + this._actualItinerary["id"] + "/fly";
    this._itineraryService._restService.doGet("app", url).subscribe({
      next: (response: any) => {
        if (response["data"] && response["data"][0]) {
          const flight = response["data"][0];
          this._flightInfo = {
            departureIn: new Date(flight["departureIn"]),
            arrivalIn: new Date(flight["arrivalIn"]),
            airportIn: flight["airportIn"],
            airlineIn: flight["airlineIn"],
            flyNumberIn: flight["flyNumberIn"],
            departureOut: new Date(flight["departureOut"]),
            arrivalOut: new Date(flight["arrivalOut"]),
            airportOut: flight["airportOut"],
            airlineOut: flight["airlineOut"],
            flyNumberOut: flight["flyNumberOut"],
          };
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log("Has no flights associated", error);
      }
    });
  }
}


/** Carga `this.suggestions` desde el endpoint `suggestionsByID/{id}`. */
getSuggestionsBig() {
  const url = "suggestionsByID/" + this._actualItinerary.id;
  this.restService.doGet("app", url).subscribe({
    next: (data: any) => {
      this.suggestions = data.suggestions;
    },
    error: (error: HttpErrorResponse) => {
      console.log("error response", error);
    }
  });
}

/**
 * @param qty Cantidad de ítems seleccionados para reserva parcial.
 */
_itemToPartial(qty: number) {
  this.qtyItemsToPartial = qty;
}

/** Delega al componente hijo para proceder con la reserva. */
goReserveFee() {
  this.yourTripSummaryComponent.goToReserve();
}

         /** Recalcula y guarda en `netPriceAgent` el total usando el campo `netPriceAgent`. */
getTotalTarifa() {
  this.netPriceAgent = this.calculateTotal('netPriceAgent');
}

/**
 * @param fieldName Campo del itinerary a sumar (ej: 'netPriceAgent').
 * @returns Total calculado por el servicio, ya convertido a la moneda de la agencia.
 */
private calculateTotal(fieldName: string): number {
  return this._itineraryService.calculateTotal(
    fieldName,
    this._actualItinerary,
    this.currencies,
    this.currencyAgency
  );
}

getItinerarySummary(): void {
  this.restService.doGet('app', 'summaryItinerary/'+this._actualItinerary.id, { params: { hide_flights: true } }).subscribe({
    next: (res: any) => {
      if(res && res.length > 0) {
        this.summaryItinerary = [];
        this.buildSummaryFromBackend(res);
        this.getSuggestionsByDate();
      }
    },
  });
}

/**
 * Construye `this.summaryItinerary` desde la respuesta del backend:
 * agrupa destinos por iata, extrae seguros de destinos solo-seguros y
 * delega el procesamiento a `parsePeriods`.
 * @param res Array crudo de destinos/días devuelto por `summaryItinerary`.
 */
private buildSummaryFromBackend(res: any[]): void {
  const groupedData = this.groupDestinationsByIata(res);
  const { filtered, extractedInsurances } = this.extractAndFilterInsuranceDestinations(groupedData);
  this.parsePeriods(filtered, extractedInsurances);
}

/**
 * Carga sugerencias por fecha desde `itineraries/suggestions-by-date/{id}` y las
 * inyecta en los días existentes de `summaryItinerary`.
 */
getSuggestionsByDate(): void {
  const url: string = `itineraries/suggestions-by-date/${this._actualItinerary.id}?add_transfer_suggestions=true`;
  this.restService.doGet('app', url).subscribe({
    next: (res: any) => {
      if (res.cod === 200 && res.data) {
          this.injectSuggestionsIntoExistingDays(res.data);
      }
    },
    error: (error: any) => {
      console.log('[getSuggestionsByDate] Error:', error);
    }
  });
}

  /**
   * Asigna `dateSuggestions` a cada día que tenga sugerencias para su fecha.
   * Los días de checkout no reciben sugerencias.
   * @param suggestionsByDate Mapa `YYYY-MM-DD -> array de sugerencias`.
   */
  injectSuggestionsIntoExistingDays(suggestionsByDate: { [date: string]: any[] }): void {
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    this.summaryItinerary.forEach(destination => {
      const days = destination.days || [];

      days.forEach((day: any) => {
        if (!day.full_date) return;

        if (day._isCheckoutDay) return;

        const suggestions = suggestionsByDate[day.full_date];
        if (suggestions && suggestions.length > 0) {
          day.dateSuggestions = suggestions;
        }
      });
    });
  }

  private formatDateShort(dateStr: string): string {
  // Parse manual: new Date("YYYY-MM-DD") es UTC midnight y en UTC-3 cae en el día anterior.
  const parts = dateStr.split('-');
  const day = parseInt(parts[2], 10);
  const month = parseInt(parts[1], 10);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${day} ${monthNames[month - 1]}.`;
}

  /**
   * Genera días intermedios vacíos entre el primer y último día de cada destino,
   * extendiendo el rango con actividades y con los rangos de los seguros.
   * Marca `_isCheckoutDay` y `_breakfastInfo` en los días correspondientes.
   * @param insurances Seguros extraídos para extender el rango si caen fuera de los días del destino.
   */
  private fillMissingDays(data: any[], insurances?: { activity: any; startDate: string; endDate: string }[]): any[] {
    return data.map((destination: any) => {
      const existingDays = destination.days || [];
      if (existingDays.length === 0) return destination;

      const sortedDates = existingDays
        .map((d: any) => d.full_date)
        .filter((d: any) => d)
        .sort();

      if (sortedDates.length === 0) return destination;

      let startDateStr = sortedDates[0];
      let endDateStr = sortedDates[sortedDates.length - 1];

      // Extender con rangos de actividades para que cualquier categoría con
      // rango multi-día genere sus intermedios.
      const activityRange = this.extractActivityDateRanges(existingDays);
      if (activityRange.minDate && activityRange.minDate < startDateStr) {
        startDateStr = activityRange.minDate;
      }
      if (activityRange.maxDate && activityRange.maxDate > endDateStr) {
        endDateStr = activityRange.maxDate;
      }

      // Extender con rangos de seguros extraídos (pueden caer fuera de los
      // días del destino si el hotel está en otras fechas).
      if (insurances && insurances.length > 0) {
        for (const ins of insurances) {
          const insStart = this.normalizeDateToYYYYMMDD(ins.startDate);
          const insEnd = this.normalizeDateToYYYYMMDD(ins.endDate);
          if (insStart && insStart < startDateStr) startDateStr = insStart;
          if (insEnd && insEnd > endDateStr) endDateStr = insEnd;
        }
      }

      // Rango de un solo día: solo renombrar el day_title (el backend puede
      // venir con "Dia 4 - Origen", queremos "Dia 1 - Ciudad").
      if (startDateStr === endDateStr) {
        const dayIndex = existingDays.findIndex((d: any) => d.full_date === startDateStr);
        if (dayIndex !== -1) {
          existingDays[dayIndex].day_title = `Dia 1 - ${destination.city_name}`;
        }
        return {
          ...destination,
          days: existingDays
        };
      }

      const daysByDate = new Map<string, any>();
      existingDays.forEach((d: any) => {
        if (d.full_date) daysByDate.set(d.full_date, d);
      });

      const hotelStayRanges: {
        startDate: string;
        endDate: string;
        hotelName: string;
        rooms: { name: string; hasBreakfast: boolean }[];
        hasAnyBreakfast: boolean;
        checkoutTime: string;
      }[] = [];
      existingDays.forEach((day: any) => {
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return;
        ['morning', 'afternoon', 'night'].forEach(period => {
          if (!Array.isArray(periods[period])) return;
          periods[period].forEach((act: any) => {
            // Barcos: misma estadía que un hotel (días libres entre medio y Check-Out el último día).
            if (act?.activity?.categoryName === 'BOATS') {
              try {
                const boat = typeof act.activity.item === 'string'
                  ? JSON.parse(act.activity.item)
                  : act.activity.item;
                const boatStart = this.normalizeDateToYYYYMMDD(boat?.arrivalDate);
                const boatEnd = this.normalizeDateToYYYYMMDD(boat?.departureDate);
                const boatName = act.activity.title || boat?.title || '';

                if (boatStart && boatEnd && !hotelStayRanges.some(h => h.hotelName === boatName && h.startDate === boatStart)) {
                  hotelStayRanges.push({
                    startDate: boatStart,
                    endDate: boatEnd,
                    hotelName: boatName,
                    checkoutTime: boat?.checkOutTime || '',
                    rooms: [],
                    hasAnyBreakfast: false
                  });
                }
              } catch (e) {
                console.warn('[fillMissingDays] Error parsing boat item:', e);
              }
              return;
            }

            if (act?.activity?.categoryName === 'HOTELS') {
              try {
                const activityData = typeof act.activity.item === 'string'
                  ? JSON.parse(act.activity.item)
                  : act.activity.item;

                if (activityData?.stay?.startDate && activityData?.stay?.endDate) {
                  const existingRange = hotelStayRanges.find(h =>
                    h.startDate === activityData.stay.startDate &&
                    h.endDate === activityData.stay.endDate &&
                    h.hotelName === act.activity.title
                  );

                  if (!existingRange) {
                    const boardName = (activityData?.boardName || activityData?.room?.boardName || '').toUpperCase();
                    const hasBreakfast = boardName.includes('BREAKFAST') || boardName.includes('HALF BOARD') || boardName.includes('FULL BOARD') || boardName.includes('CON DESAYUNO');
                    const item = JSON.parse(act.activity.item);
                    const timeCheckout = item.hotelAdditionalInfo.length ? item.hotelAdditionalInfo[0].TimeInformation.checkOut : '-';

                    hotelStayRanges.push({
                      startDate: activityData.stay.startDate,
                      endDate: activityData.stay.endDate,
                      hotelName: act.activity.title || item.title || '',
                      checkoutTime: timeCheckout,
                      rooms: [{
                        name: act.activity.room?.name || act.activity.room?.description || boardName || 'Habitación',
                        hasBreakfast: hasBreakfast
                      }],
                      hasAnyBreakfast: hasBreakfast
                    });
                  } else {
                    const boardName = (activityData?.boardName || activityData?.room?.boardName || '').toUpperCase();
                    const hasBreakfast = boardName.includes('BREAKFAST') || boardName.includes('HALF BOARD') || boardName.includes('FULL BOARD');
                    existingRange.rooms.push({
                      name: act.activity.room?.name || act.activity.room?.description || boardName || 'Habitación',
                      hasBreakfast: hasBreakfast
                    });
                    if (hasBreakfast) {
                      existingRange.hasAnyBreakfast = true;
                    }
                  }
                }
              } catch (e) {
                console.warn('[fillMissingDays] Error parsing hotel item:', e);
              }
            }
          });
        });
      });

      // Marcar _isCheckoutDay también en días existentes del backend, no solo
      // en los intermedios generados abajo. Sin esto, un día que ya viene con
      // actividades (ej: transfer-out) no muestra el Check-Out porque la lógica
      // vivía solo en el `else` del while.
      existingDays.forEach((day: any) => {
        if (!day.full_date) return;
        const checkoutHotels = hotelStayRanges.filter(hotel => hotel.endDate === day.full_date);
        if (checkoutHotels.length === 0) return;
        const checkoutHotel = checkoutHotels.find(h =>
          !hotelStayRanges.some(m => m.hotelName === h.hotelName && m.startDate === h.startDate)
        ) || checkoutHotels[0];
        day._isCheckoutDay = true;
        day._checkoutHotelInfo = {
          title: checkoutHotel.hotelName,
          time: checkoutHotel.checkoutTime
        };
      });

      // Generar todas las fechas en el rango
      const allDays: any[] = [];
      let currentDateStr = startDateStr;

      while (currentDateStr <= endDateStr) {
        if (daysByDate.has(currentDateStr)) {
          allDays.push(daysByDate.get(currentDateStr));
        } else {
          const matchingHotels = hotelStayRanges.filter(hotel =>
            currentDateStr >= hotel.startDate && currentDateStr < hotel.endDate
          );

          const checkoutHotels = hotelStayRanges.filter(hotel => hotel.endDate === currentDateStr);

          let breakfastInfo: any = null;
          let checkoutHotelInfo: any = null;
          if (matchingHotels.length > 0) {
            const hotel = matchingHotels[0];
            const roomWithBreakfast = hotel.rooms.find((r: any) => r.hasBreakfast);
            breakfastInfo = {
              hotelName: hotel.hotelName,
              roomName: roomWithBreakfast?.name || hotel.rooms[0]?.name || '',
              hasBreakfast: hotel.hasAnyBreakfast
            };
          }

          // Si el hotel que termina overlapping con un check-in del siguiente rango,
          // preferir el que NO inicia ese día (mantener comportamiento legacy).
          if (checkoutHotels.length > 0) {
            const checkoutHotel = checkoutHotels.find(h =>
              !matchingHotels.some(m => m.hotelName === h.hotelName && m.startDate === h.startDate)
            ) || checkoutHotels[0];

            checkoutHotelInfo = {
              title: checkoutHotel.hotelName,
              time: checkoutHotel.checkoutTime
            };
          }

          allDays.push({
            full_date: currentDateStr,
            date: this.formatDateShort(currentDateStr),
            day_title: '',
            has_airport_transfer: false,
            activities: { morning: [], afternoon: [], night: [] },
            _isGenerated: true,
            _breakfastInfo: breakfastInfo,
            _isCheckoutDay: !!checkoutHotelInfo,
            _checkoutHotelInfo: checkoutHotelInfo
          });
        }
        currentDateStr = this.addDaysToDate(currentDateStr, 1);
      }

      allDays.forEach((day: any, index: number) => {
        day.day_title = `Dia ${index + 1} - ${destination.city_name}`;
      });

      return {
        ...destination,
        days: allDays
      };
    });
  }

  /**
   * Filtra destinos que solo contienen seguros y devuelve los seguros extraídos
   * para que `parsePeriods` los inyecte como marcadores en destinos reales.
   *
   * TODO: cuando el backend asocie seguros a un destino específico, casarlos por ese dato.
   */
  private extractAndFilterInsuranceDestinations(destinations: any[]): {
    filtered: any[];
    extractedInsurances: { activity: any; startDate: string; endDate: string }[];
  } {
    const extractedInsurances: { activity: any; startDate: string; endDate: string }[] = [];

    const filtered = destinations.filter((destination: any) => {
      const hasNonInsuranceActivity = (destination.days || []).some((day: any) => {
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return false;
        return ['morning', 'afternoon', 'night'].some(p =>
          Array.isArray(periods[p]) && periods[p].some((act: any) =>
            act?.activity?.category_id !== 10 && act?.activity?.categoryName !== 'INSURANCE'
          )
        );
      });

      if (!hasNonInsuranceActivity) {
        (destination.days || []).forEach((day: any) => {
          const periods = day.activities;
          if (!periods || typeof periods !== 'object') return;
          ['morning', 'afternoon', 'night'].forEach(period => {
            if (!Array.isArray(periods[period])) return;
            periods[period].forEach((act: any) => {
              if (act?.activity?.category_id === 10 || act?.activity?.categoryName === 'INSURANCE') {
                try {
                  const item = typeof act.activity.item === 'string'
                    ? JSON.parse(act.activity.item)
                    : act.activity.item;

                  // payload.dateBegin/dateEnd son fechas sin timezone; form.beginDateEndDate
                  // puede traer "2026-06-07T03:59:59Z" que en UTC-3 es 06-06.
                  const startDate = item?.payload?.dateBegin
                    || act.activity.arrivalDate
                    || (item?.form?.beginDateEndDate?.start
                      ? item.form.beginDateEndDate.start.split('T')[0]
                      : null);

                  const endDate = item?.payload?.dateEnd
                    || act.activity.departureDate
                    || (item?.form?.beginDateEndDate?.end
                      ? item.form.beginDateEndDate.end.split('T')[0]
                      : null);

                  if (startDate && endDate) {
                    extractedInsurances.push({
                      activity: act.activity,
                      startDate,
                      endDate
                    });
                  }
                } catch (e) {
                  if (act.activity.arrivalDate && act.activity.departureDate) {
                    extractedInsurances.push({
                      activity: act.activity,
                      startDate: act.activity.arrivalDate,
                      endDate: act.activity.departureDate
                    });
                  }
                }
              }
            });
          });
        });
        return false;
      }

      return true;
    });

    return { filtered, extractedInsurances };
  }

  /**
   * Fusiona destinos con el mismo `iata_code` en uno solo, deduplicando días por fecha.
   *
   * TODO: mover esta agrupación al backend.
   */
  private groupDestinationsByIata(destinations: any[]): any[] {
    if (!destinations || destinations.length === 0) return destinations;

    const groupedMap = new Map<string, any>();

    destinations.forEach((dest: any) => {
      const iata = dest.iata_code;
      if (!iata) return;

      if (!groupedMap.has(iata)) {
        groupedMap.set(iata, {
          ...dest,
          days: [...(dest.days || [])]
        });
      } else {
        const existing = groupedMap.get(iata)!;
        const existingDates = new Set(
          (existing.days || []).map((d: any) => d.full_date).filter(Boolean)
        );

        (dest.days || []).forEach((day: any) => {
          if (day.full_date && !existingDates.has(day.full_date)) {
            existing.days.push(day);
            existingDates.add(day.full_date);
          }
        });
      }
    });

    groupedMap.forEach((dest: any) => {
      if (dest.days && dest.days.length > 0) {
        dest.days.sort((a: any, b: any) => {
          if (!a.full_date || !b.full_date) return 0;
          return a.full_date.localeCompare(b.full_date);
        });
      }
    });

    return Array.from(groupedMap.values());
  }

  /**
 * @param dateStr Fecha en formato YYYY-MM-DD.
 * @param days Días a sumar (puede ser negativo).
 * @returns Fecha resultante en formato YYYY-MM-DD, sin偏移 de timezone.
 */
  private addDaysToDate(dateStr: string, days: number): string {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + days);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  /**
 * Devuelve el rango mínimo (startDate) y máximo (endDate) entre todas las
 * actividades de los días dados. Útil para extender el rango de días intermedios
 * más allá de los días que el backend ya proveyó.
 */
  private extractActivityDateRanges(days: any[]): { minDate: string | null; maxDate: string | null } {
    let minDate: string | null = null;
    let maxDate: string | null = null;

    days.forEach((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return;

      ['morning', 'afternoon', 'night'].forEach(period => {
        if (!Array.isArray(periods[period])) return;
        periods[period].forEach((act: any) => {
          const activity = act?.activity;
          if (!activity) return;

          try {
            const item = typeof activity.item === 'string'
              ? JSON.parse(activity.item)
              : activity.item;

            if (!item) return;

            const isInsurance = activity.category_id === 10 || activity.categoryName === 'INSURANCE';

            let startDate: string | null = null;
            let endDate: string | null = null;

            if (isInsurance) {
              startDate = item?.payload?.dateBegin
                || activity.arrivalDate
                || (item?.form?.beginDateEndDate?.start
                  ? item.form.beginDateEndDate.start.split('T')[0]
                  : null);
              endDate = item?.payload?.dateEnd
                || activity.departureDate
                || (item?.form?.beginDateEndDate?.end
                  ? item.form.beginDateEndDate.end.split('T')[0]
                  : null);
            } else {
              // Hoteles usan stay.*; otras categorías usan arrivalDate/departureDate.
              if (item.stay?.startDate) {
                startDate = this.normalizeDateToYYYYMMDD(item.stay.startDate);
              } else if (item.arrivalDate) {
                startDate = this.normalizeDateToYYYYMMDD(item.arrivalDate);
              }

              if (item.stay?.endDate) {
                endDate = this.normalizeDateToYYYYMMDD(item.stay.endDate);
              } else if (item.departureDate) {
                endDate = this.normalizeDateToYYYYMMDD(item.departureDate);
              }
            }

            if (startDate && (!minDate || startDate < minDate)) {
              minDate = startDate;
            }
            if (endDate && (!maxDate || endDate > maxDate)) {
              maxDate = endDate;
            }
          } catch (e) {
            // ignore: item no parseable
          }
        });
      });
    });

    return { minDate, maxDate };
  }

addSuggestionsToActivities(activitiesArray: any[], suggestionsData: any): void {
  if (!activitiesArray || !suggestionsData) {
    console.error('❌ Faltan datos para procesar sugerencias');
    return;
  }

  let totalActivities = 0;
  let suggestionsAssigned = 0;

  activitiesArray.forEach(city => {
    city.days?.forEach((day: any) => {
      if (!day.activities) return;

      ['morning', 'afternoon', 'night'].forEach(period => {
        const periodActivities = day.activities[period];

        if (!periodActivities) return;
        periodActivities.forEach((activity: any) => {
          totalActivities++;
          const activityId = activity?.activity?.id;
          const suggestions = suggestionsData[activityId];

          if (activityId && suggestions) {
            activity.activity.suggestionIA = suggestions;
            suggestionsAssigned++;
          }
        });
      });
    });
  });
}

addSuggestionsToParsedPeriods(activitiesArray: any[], suggestionsData: any): void {
  if (!activitiesArray || !suggestionsData) {
    console.error('❌ Faltan datos para procesar sugerencias');
    return;
  }

  let totalActivities = 0;
  let suggestionsAssigned = 0;


  activitiesArray.forEach((city, cityIndex) => {

    city.days?.forEach((day: any, dayIndex) => {
      // Opción 1: Usar parsedPeriods (nueva estructura)
      if (day.parsedPeriods && Array.isArray(day.parsedPeriods)) {

        day.parsedPeriods.forEach((parsedPeriod: any, periodIndex) => {

          if (parsedPeriod.activities && Array.isArray(parsedPeriod.activities)) {

            parsedPeriod.activities.forEach((activity: any, activityIndex) => {
              totalActivities++;

              // El id está dentro de activity.activity
              const activityId = activity?.activity?.id;

              if (activityId) {
                const suggestions = suggestionsData[activityId];

                if (suggestions) {
                  activity.activity.suggestionIA = suggestions;
                  suggestionsAssigned++;
                }
              }
            });
          }
        });
      }
      // Opción 2: Mantener compatibilidad con estructura antigua (activities)
      else if (day.activities) {
        this.addSuggestionsToActivities([city], suggestionsData); // Reutilizar función anterior
      }
    });
  });

}

parsePeriods(data: any, preExtractedInsurances?: { activity: any; startDate: string; endDate: string }[]): void {
  const filterValidActivities = (activities: any[]) => {
    if (!Array.isArray(activities)) return [];
    return activities.filter(activity => activity?.activity?.categoryName);
  };

  // title (normalizado) es la clave cross-provider más confiable para
  // identificar el mismo hotel físico (distintos idProduct/hotelCode
  // entre proveedores).
  const getHotelId = (activity: any): string => {
    try {
      const item = typeof activity.item === 'string'
        ? JSON.parse(activity.item)
        : activity.item;

      if (item?.title) return item.title.trim().toLowerCase();

      if (item?.idProduct) return String(item.idProduct);

      if (item?.room?.hotelCode) return String(item.room.hotelCode);
    } catch (e) {
      // ignore: usar uid como fallback
    }

    const uid = activity.uid || '';
    return uid.includes('|') ? uid.split('|').pop()! : uid;
  };

  const groupHotelsByUid = (activities: any[]): any[] => {
    if (!activities || activities.length === 0) return activities;

    const hotelGroups = new Map<string, any[]>();

    activities.forEach(act => {
      if (act?.activity?.categoryName !== 'HOTELS') return;

      const hotelId = getHotelId(act.activity);

      if (!hotelGroups.has(hotelId)) {
        hotelGroups.set(hotelId, []);
      }
      hotelGroups.get(hotelId)!.push(act);
    });

    const hasMultiRoom = Array.from(hotelGroups.values()).some(rooms => rooms.length > 1);
    if (!hasMultiRoom) return activities;

    const seenHotelIds = new Set<string>();
    const result: any[] = [];

    activities.forEach(act => {
      if (act?.activity?.categoryName !== 'HOTELS') {
        result.push(act);
        return;
      }

      const hotelId = getHotelId(act.activity);

      if (seenHotelIds.has(hotelId)) return;
      seenHotelIds.add(hotelId);

      const rooms = hotelGroups.get(hotelId)!;

      if (rooms.length === 1) {
        result.push(rooms[0]);
      } else {
        result.push({
          ...rooms[0],
          activity: {
            ...rooms[0].activity,
            _isGroupedHotel: true,
            _groupedRooms: rooms.map(r => r.activity)
          }
        });
      }
    });

    return result;
  };

  // Recolectar seguros de todos los destinos (incluyendo los pre-extraídos
  // de destinos solo-seguros).
  const allInsurances: { activity: any; startDate: string; endDate: string }[] = [
    ...(preExtractedInsurances || [])
  ];

  const dataWithoutInsurances = data.map((destination: any) => {
    const filteredDays = (destination.days || []).map((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return day;

      const filteredPeriods: any = {};
      ['morning', 'afternoon', 'night'].forEach(period => {
        if (!Array.isArray(periods[period])) {
          filteredPeriods[period] = [];
          return;
        }

        filteredPeriods[period] = periods[period].filter((act: any) => {
          if (act?.activity?.category_id === 10 || act?.activity?.categoryName === 'INSURANCE') {
            try {
              const item = typeof act.activity.item === 'string'
                ? JSON.parse(act.activity.item)
                : act.activity.item;

              // payload.dateBegin/dateEnd son fechas sin timezone;
              // form.beginDateEndDate puede traer "2026-06-07T03:59:59Z"
              // que en UTC-3 es 06-06.
              const startDate = item?.payload?.dateBegin
                || act.activity.arrivalDate
                || (item?.form?.beginDateEndDate?.start
                  ? item.form.beginDateEndDate.start.split('T')[0]
                  : null);

              const endDate = item?.payload?.dateEnd
                || act.activity.departureDate
                || (item?.form?.beginDateEndDate?.end
                  ? item.form.beginDateEndDate.end.split('T')[0]
                  : null);

              if (startDate && endDate) {
                allInsurances.push({
                  activity: act.activity,
                  startDate,
                  endDate
                });
              }
            } catch (e) {
              if (act.activity.arrivalDate && act.activity.departureDate) {
                allInsurances.push({
                  activity: act.activity,
                  startDate: act.activity.arrivalDate,
                  endDate: act.activity.departureDate
                });
              }
            }
            return false;
          }
          return true;
        });
      });

      return {
        ...day,
        activities: filteredPeriods
      };
    });

    return {
      ...destination,
      days: filteredDays
    };
  });

  const dataCleaned = dataWithoutInsurances.filter((destination: any) => {
    const hasNonInsuranceActivities = (destination.days || []).some((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return false;
      return ['morning', 'afternoon', 'night'].some(p =>
        Array.isArray(periods[p]) && periods[p].length > 0
      );
    });
    const hasGeneratedDays = (destination.days || []).some((d: any) => d._isGenerated);
    return hasNonInsuranceActivities || hasGeneratedDays;
  });

  // Fallback: si todos los destinos eran solo-seguros, generar uno sintético
  // para que el template renderice la asistencia.
  let dataWithSyntheticDestination = dataCleaned;
  if (dataCleaned.length === 0 && allInsurances.length > 0) {
    dataWithSyntheticDestination = this.buildSyntheticInsuranceDestination(allInsurances);
  }

  // fillMissingDays con los seguros ya conocidos: su rango extiende el de los
  // destinos para que las fechas del seguro tengan días donde marcarse.
  const dataWithFilledDays = this.fillMissingDays(dataWithSyntheticDestination, allInsurances);

  this.summaryItinerary = dataWithFilledDays.map((destination: any) => {
    const destinationHasHotel = (destination.days || []).some((day: any) => {
      const periods = day.activities;
      if (!periods || typeof periods !== 'object') return false;
      return ['morning', 'afternoon', 'night'].some(p =>
        Array.isArray(periods[p]) && periods[p].some((a: any) =>
          a?.activity?.categoryName === 'HOTELS'
        )
      );
    });

    return {
      ...destination,
      destinationHasHotel,
      days: destination.days.map((day: any) => {
        const periods = day.activities;

        if (!periods || typeof periods !== 'object') {
          return {
            ...day,
            parsedPeriods: [],
            isFreeDay: true,
            destinationHasHotel: destinationHasHotel,
            _breakfastInfo: day._breakfastInfo || null,
            _isCheckoutDay: day._isCheckoutDay || false,
            _checkoutHotelInfo: day._checkoutHotelInfo || null
          };
        }

        const modifiedPeriods = {
          morning: groupHotelsByUid(filterValidActivities(periods.morning || [])),
          afternoon: groupHotelsByUid(filterValidActivities(periods.afternoon || [])),
          night: groupHotelsByUid(filterValidActivities(periods.night || []))
        };

        // Días intermedios (_isGenerated) muestran "Mañana" en vez de "Tarde"
        // cuando el hotel está clonado del día anterior.
        const isGeneratedDay = day._isGenerated;
        const parsedPeriods = [
          {
            key: 'morning',
            label: 'Mañana',
            activities: modifiedPeriods.morning
          },
          {
            key: 'afternoon',
            label: isGeneratedDay ? 'Mañana' : 'Tarde',
            activities: modifiedPeriods.afternoon
          },
          {
            key: 'night',
            label: 'Noche',
            activities: modifiedPeriods.night
          }
        ].filter(period =>
          Array.isArray(period.activities) && period.activities.length > 0
        );

        return {
          ...day,
          activities: modifiedPeriods,
          parsedPeriods: parsedPeriods,
          isFreeDay: parsedPeriods.length === 0,
          destinationHasHotel: destinationHasHotel,
          _breakfastInfo: day._breakfastInfo || null,
          _isCheckoutDay: day._isCheckoutDay || false,
          _checkoutHotelInfo: day._checkoutHotelInfo || null
        };
      })
    };

  });

  this.injectInsurancesIntoDays(allInsurances);

  // Backend envía rent-a-car solo en día pickup; clonamos al día de devolución
  // marcado con ckeckout: true para que el template muestre "Out".
  this.injectRentacarCheckoutDays();

  // Renumerar días globalmente por full_date: fillMissingDays() numera por
  // destino (resetea a Dia 1 en cada ciudad). Aquí damos numeración continua
  // a través de todos los destinos del itinerario.
  const allDaysGlobal: { day: any; destination: any }[] = [];
  this.summaryItinerary.forEach((destination: any) => {
    (destination.days || []).forEach((day: any) => {
      if (day.full_date) {
        allDaysGlobal.push({ day, destination });
      }
    });
  });
  allDaysGlobal.sort((a, b) => a.day.full_date.localeCompare(b.day.full_date));
  allDaysGlobal.forEach((item, index) => {
    const match = item.day.day_title?.match(/Dia\s+\d+\s*-\s*(.+)/i);
    const suffix = match ? match[1].trim() : item.destination.city_name;
    item.day.day_title = `Dia ${index + 1} - ${suffix}`;
  });

  if(this.summaryItinerary && this.summaryItinerary.length > 0) {
    setTimeout(() => {
      this.appLoading = false;

      if(this.reloadItinerary) {

        this.reloadItinerary = false;
        if (this._loadingTimeout) {
          clearTimeout(this._loadingTimeout);
          this._loadingTimeout = null;
        }
      }
    }, 150);
  }
}

  /**
   * Marca cada día con `_insurancesActive` (cuando es `startDate`) y/o
   * `_insurancesEnded` (cuando es `endDate`).
   * @param insurances Seguros con sus fechas startDate/endDate normalizadas.
   */
  private injectInsurancesIntoDays(insurances: { activity: any; startDate: string; endDate: string }[]): void {
    if (!insurances || insurances.length === 0) return;
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    const normalizedInsurances = insurances.map(ins => ({
      ...ins,
      startDate: this.normalizeDateToYYYYMMDD(ins.startDate),
      endDate: this.normalizeDateToYYYYMMDD(ins.endDate)
    }));

    this.summaryItinerary.forEach((destination: any) => {
      const days = destination.days || [];
      if (days.length === 0) return;

      days.forEach((day: any) => {
        if (!day.full_date) return;

        const activeInsurances = normalizedInsurances.filter(
          ins => ins.startDate === day.full_date
        );

        const endedInsurances = normalizedInsurances.filter(
          ins => ins.endDate === day.full_date
        );

        if (activeInsurances.length > 0) {
          day._insurancesActive = activeInsurances.map(ins => ({
            ...ins.activity,
            item: JSON.parse(ins.activity.item),
            _status: 'active',
            _title: ins.activity.item?.title || ins.activity.title || '',
            _image: ins.activity.item?.images?.[0] || '',
            _startDate: ins.startDate,
            _endDate: ins.endDate
          }));
          day._insurancesExpanded = false;
        }

        if (endedInsurances.length > 0) {
          day._insurancesEnded = endedInsurances.map(ins => ({
            ...ins.activity,
            item: JSON.parse(ins.activity.item),
            _status: 'ended',
            _title: ins.activity.item?.title || ins.activity.title || '',
            _image: ins.activity.item?.images?.[0] || '',
            _startDate: ins.startDate,
            _endDate: ins.endDate
          }));
          day._insurancesEndedExpanded = false;
        }
      });
    });
  }

  /**
   * Clona cada rent-a-car en su día de devolución (`departureDate`) marcado con
   * `ckeckout: true`, para que el template muestre "Out". El backend solo envía
   * la actividad en el día de pickup.
   */
  private injectRentacarCheckoutDays(): void {
    if (!this.summaryItinerary || this.summaryItinerary.length === 0) return;

    const rentacarCheckouts: { activity: any; departureDate: string; destinationIata: string }[] = [];

    this.summaryItinerary.forEach((destination: any) => {
      const days = destination.days || [];
      days.forEach((day: any) => {
        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return;

        ['morning', 'afternoon', 'night'].forEach(period => {
          if (!Array.isArray(periods[period])) return;
          periods[period].forEach((act: any) => {
            if (act?.activity?.categoryName !== 'RENT-A-CAR' && act?.activity?.category_id !== 2) return;

            try {
              const item = typeof act.activity.item === 'string'
                ? JSON.parse(act.activity.item)
                : act.activity.item;

              const departureDate = item?.departureDate
                ? this.normalizeDateToYYYYMMDD(item.departureDate)
                : null;

              if (departureDate) {
                rentacarCheckouts.push({
                  activity: act.activity,
                  departureDate,
                  destinationIata: destination.iata_code
                });
              }
            } catch (e) {
              if (act.activity.departureDate) {
                rentacarCheckouts.push({
                  activity: act.activity,
                  departureDate: this.normalizeDateToYYYYMMDD(act.activity.departureDate),
                  destinationIata: destination.iata_code
                });
              }
            }
          });
        });
      });
    });

    if (rentacarCheckouts.length === 0) return;

    this.summaryItinerary.forEach((destination: any) => {
      const days = destination.days || [];
      if (days.length === 0) return;

      days.forEach((day: any) => {
        if (!day.full_date) return;

        const matchingRentacars = rentacarCheckouts.filter(
          rc => rc.departureDate === day.full_date && rc.destinationIata === destination.iata_code
        );

        if (matchingRentacars.length === 0) return;

        const periods = day.activities;
        if (!periods || typeof periods !== 'object') return;

        const existingRentacarIds = new Set<number>();
        ['morning', 'afternoon', 'night'].forEach(period => {
          if (!Array.isArray(periods[period])) return;
          periods[period].forEach((act: any) => {
            if (act?.activity?.categoryName === 'RENT-A-CAR' || act?.activity?.category_id === 2) {
              existingRentacarIds.add(act.activity.id);
            }
          });
        });

        matchingRentacars.forEach(rc => {
          if (existingRentacarIds.has(rc.activity.id)) return;

          const checkoutActivity = {
            activity: {
              ...rc.activity,
              ckeckout: true
            }
          };

          if (!Array.isArray(day.activities.morning)) {
            day.activities.morning = [];
          }
          day.activities.morning.push(checkoutActivity);

          if (day.parsedPeriods && Array.isArray(day.parsedPeriods)) {
            const morningPeriod = day.parsedPeriods.find((p: any) => p.key === 'morning');
            if (morningPeriod) {
              if (!Array.isArray(morningPeriod.activities)) {
                morningPeriod.activities = [];
              }
              morningPeriod.activities.push(checkoutActivity);
            } else {
              day.parsedPeriods.unshift({
                key: 'morning',
                label: 'Mañana',
                activities: [checkoutActivity]
              });
            }
          }

          day.isFreeDay = false;

          existingRentacarIds.add(rc.activity.id);
        });
      });
    });
  }

  /**
 * Construye destinos virtuales cuando el itinerario contiene solo seguros
 * (sin hoteles ni traslados). Cada destino agrupa seguros por `iata_code` y
 * crea días a partir de su rango de fechas.
 * @param insurances Seguros extraídos del backend.
 * @returns Array de destinos sintéticos (uno por iata), o [] si no hay seguros.
 */
  private buildSyntheticInsuranceDestination(insurances: { activity: any; startDate: string; endDate: string }[]): any[] {
    if (!insurances || insurances.length === 0) return [];

    const byIata = new Map<string, typeof insurances>();
    insurances.forEach(ins => {
      const iata = ins.activity.destination_iata
        || ins.activity.destination?.iata_code
        || 'INSURANCE';
      if (!byIata.has(iata)) {
        byIata.set(iata, []);
      }
      byIata.get(iata)!.push(ins);
    });

    const syntheticDestinations: any[] = [];

    byIata.forEach((igroup, iata) => {
      const firstInsurance = igroup[0];
      let cityName = 'Asistencia al viajero';
      try {
        const item = typeof firstInsurance.activity.item === 'string'
          ? JSON.parse(firstInsurance.activity.item)
          : firstInsurance.activity.item;
        if (item?.title) {
          cityName = item.title;
        } else if (item?.payload?.name) {
          cityName = item.payload.name;
        }
      } catch (e) {
        // Mantener el literal por defecto
      }

      const allDates = new Set<string>();
      igroup.forEach(ins => {
        let current = this.normalizeDateToYYYYMMDD(ins.startDate);
        const end = this.normalizeDateToYYYYMMDD(ins.endDate);
        while (current <= end) {
          allDates.add(current);
          current = this.addDaysToDate(current, 1);
        }
      });

      const sortedDates = Array.from(allDates).sort();
      const syntheticDays: any[] = [];

      sortedDates.forEach((dateStr, index) => {
        const dayInsurancesActive: any[] = [];
        const dayInsurancesEnded: any[] = [];

        igroup.forEach(ins => {
          const start = this.normalizeDateToYYYYMMDD(ins.startDate);
          const end = this.normalizeDateToYYYYMMDD(ins.endDate);
          if (dateStr === start) {
            dayInsurancesActive.push(ins);
          }
          if (dateStr === end) {
            dayInsurancesEnded.push(ins);
          }
        });

        syntheticDays.push({
          full_date: dateStr,
          date: this.formatDateShort(dateStr),
          day_title: `Dia ${index + 1} - Asistencia al viajero`,
          has_airport_transfer: false,
          activities: { morning: [], afternoon: [], night: [] },
          parsedPeriods: [],
          isFreeDay: true,
          _insurancesActive: dayInsurancesActive.length > 0 ? dayInsurancesActive : undefined,
          _insurancesEnded: dayInsurancesEnded.length > 0 ? dayInsurancesEnded : undefined,
          _insurancesExpanded: false,
          _insurancesEndedExpanded: false
        });
      });

      syntheticDestinations.push({
        iata_code: iata,
        city_name: cityName,
        days: syntheticDays,
        _isSyntheticInsuranceDestination: true
      });
    });

    return syntheticDestinations;
  }

  /**
 * Normaliza una fecha a formato YYYY-MM-DD.
 * Acepta ISO con tiempo (`2026-06-07T04:00:00.000Z`) o fecha simple (`2026-06-07`).
 */
  private normalizeDateToYYYYMMDD(dateStr: string): string {
    if (!dateStr) return '';
    return dateStr.split('T')[0];
  }

   reloadSummaryItineraryFx(): void {
   this.reloadItinerary = true;
   this.summaryItinerary = [];
   this.scrollToTop();

   if (this._loadingTimeout) {
     clearTimeout(this._loadingTimeout);
   }
   this._loadingTimeout = setTimeout(() => {
     if (this.reloadItinerary) {
       console.warn('reloadSummaryItineraryFx: safety timeout — backend no respondió en 10s');
       this.getItinerarySummary();
     }
   }, 10000);
 }

private scrollToTop(): void {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });

}

/** Logo de la agencia, o la imagen por defecto si está vacío o apunta al storage del backend. */
get agencyImagen(): string {
  const img = this.userService._imagen_logotype;
  return (!img || img === this.routerStorage) ? 'assets/img/sin-logo.png' : img;
}

}
